import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class InventoryTransformations_ds_inventory_transformations_hubService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, LookupCode?: string, StatusId?: number, InventoryTransformationStatus?: { Name?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { Id?: number, LookupCode?: string } }, Warehouse?: { Id?: number, Name?: string } }[] }> 
  {
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_inventory_transformations_hub/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, LookupCode?: string, StatusId?: number, InventoryTransformationStatus?: { Name?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { Id?: number, LookupCode?: string } }, Warehouse?: { Id?: number, Name?: string } }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_inventory_transformations_hub/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, CreatedSysUser?: string, LookupCode?: string, StatusId?: number, InventoryTransformationStatus?: { Name?: string }, Project?: { Id?: number, LookupCode?: string, Owner?: { Id?: number, LookupCode?: string } }, Warehouse?: { Id?: number, Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/InventoryTransformations/datasources/ds_inventory_transformations_hub/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      owner_id?: number, project_id?: number, warehouse_ids?: number[], status_ids?: number[]    }) {
      return false;
    }
}
